import styled from "styled-components/macro";
import { Text, ProgressBar } from "@ds/react";

export const StepBar = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: "16px 0 0",
  gap: "16px",
  backgroundColor: theme.color.neutral["08"],

  [theme.breakpoint.lg()]: {
    padding: "24px 0 0",
    gap: "24px",
  },
}));

export const StepBarContainer = styled.div(({ theme }) => ({
  display: "flex",
  gap: "16px",

  [theme.breakpoint.sm()]: {
    gap: "20px",
  },

  [theme.breakpoint.md()]: {
    paddingLeft: "24px",
    gap: "39px",
  },

  [theme.breakpoint.lg()]: {
    paddingLeft: "24px",
    gap: "48px",
  },
}));

export const StepContainer = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
}));

export const StepBox = styled.div(({ theme, selected, pastStep }) => {
  let bgColor = theme.color.neutral["07"];
  let color = theme.color.brandPrimary.medium;
  if (pastStep) {
    bgColor = theme.color.brandPrimary.light;
    color = theme.color.neutral["08"];
  }
  if (selected) {
    bgColor = theme.color.brandSecondary.light;
    color = theme.color.neutral["08"];
  }
  return {
    color: color,
    backgroundColor: bgColor,
    width: "28px",
    heigth: "28px",
    borderRadius: "4px",
    textAlign: "center",
    padding: "4px",
    flexShrink: 0,
    fontSize: "14px",
    [theme.breakpoint.lg()]: {
      fontSize: "16px",
    },
  };
});

export const StepText = styled(Text)(({ theme }) => ({
  fontSize: "14px",
  color: theme.color.neutral["02"],
  fontWeight: "400",
  [theme.breakpoint.lg()]: {
    fontSize: "16px",
  },
}));

export const StyledProgressBar = styled(ProgressBar)(({ theme }) => ({
  width: "100vw",
  position: "relative",
  left: "-16px",

  [theme.breakpoint.lg()]: {
    width: "100%",
    left: 0,
  },

  "div[class^=ProgressBarstyle__ProgressAnimated-sc]": {
    backgroundColor: theme.color.brandSecondary.light,
  },
}));
